import { initializeClientErrorTracking } from '@/lib/sentry-client';

initializeClientErrorTracking();
